import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdiomaService } from 'src/app/services/idioma.service';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.css']
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {

  public idiomaActual: string = 'es';
  public etiquetaIdioma: string = 'Seleccionar idioma';
  private textosSubscription: Subscription;

  constructor(private _idioma: IdiomaService) { }

  ngOnInit(): void {
    this.idiomaActual = this._idioma.base === 'en' ? 'en' : 'es';
    this.textosSubscription = this._idioma.getTextos$().subscribe(textos => {
      this.etiquetaIdioma = textos?.seleccionaridioma || 'Seleccionar idioma';
    });
  }

  ngOnDestroy(): void {
    this.textosSubscription?.unsubscribe();
  }

  cambiarIdioma(): void {
    this.idiomaActual = this.idiomaActual === 'es' ? 'en' : 'es';
    this._idioma.setIdioma(this.idiomaActual);
  }
}
